import * as actions from './actions';

const initialState = {
  info: { loading: false },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_USER_SUCCESS:
      return {
        ...state,
        info: {
          ...state.info,
          ...action.payload.info,
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default reducer;
